import Permissions from '../../models/Permissions'
const FormCompany = () => import(/* webpackChunkName: "formCompany" */ './FormCompany.vue')
const GridCompanies = () => import(/* webpackChunkName: "gridCompanies" */ './GridCompanies.vue')
const SelectCompany = () => import(/* webpackChunkName: "selectCompany" */ './SelectCompany.vue')

const permissions = [
  Permissions.ROOT
]

const create = {
  path: 'company/create',
  name: 'Company',
  component: FormCompany,
  meta: {
    requiresLogin: true,
    requiresCompany: true,
    permissions: permissions
  }
}

const edit = {
  path: 'company/edit/:cnpj',
  name: 'Edit Company',
  component: FormCompany,
  props: true,
  meta: {
    requiresLogin: true,
    requiresCompany: true,
    permissions: permissions
  }
}

const list = {
  path: 'companies',
  name: 'Company List',
  component: GridCompanies,
  meta: {
    requiresLogin: true,
    requiresCompany: true,
    permissions: permissions
  }
}

const select = {
  path: 'company',
  name: 'Select Company',
  component: SelectCompany,
  meta: {
    requiresLogin: true,
    requiresCompany: false,
    permissions: []
  }
}

export default {
  create,
  edit,
  list,
  select,
  permissions
}

export {
  permissions
}
